/**
 * @desc: - 开奖前三名遮罩组件
 * @param  {[string]} className : [背景className]
 * @param  {[array]}  rank  :  [名次]
 * @author: circle
 */
import React from 'react';
import ReactDOM from 'react-dom'
import { CSSTransitionGroup } from 'react-transition-group';
export default class Timers extends React.Component {

  constructor(props) {
    super(props);
  }
 
  componentWillReceiveProps(nextProps){
    
  }

  componentWillUnmount(){

  }

  render() {
    const { rank } = this.props;
    return (
      <CSSTransitionGroup 
        transitionAppear={true} 
        transitionEnterTimeout={500} 
        transitionLeaveTimeout={500} 
        transitionAppearTimeout ={500} 
        transitionName='opacity'>
        <div className='top-rank' >
          <div className='bg' />
          <div className='bg2' />
          <ul>
            <li className={"top-" + rank[0]} ><p/></li>
            <li className={"top-" + rank[1]} ><p/></li>
            <li className={"top-" + rank[2]} ><p/></li>
          </ul>
        </div>
      </CSSTransitionGroup>
    );
  }
}